import { CarBrakeAlertIcon } from './CarBrakeAlertIcon';

/**
 * author: Michael Irigoyen
 * id 843DC5E8-723D-44A1-A959-A49C662712D1
 * name car-brake-alert
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-brake-alert.svg
 * tags
 * - Automotive 
 * - Alert / Error 
 */
export const CarHandbrakeIcon = CarBrakeAlertIcon;
export default CarHandbrakeIcon